module.exports = __webpack_public_path__ + "static/media/epsPBTC.777d76be.png";